import ReactTextareaAutocomplete from "@webscopeio/react-textarea-autocomplete";
import classNames from "classnames";
import { common_utils } from "../../../../../../common/common_utils";

export function AutocompleteInput(props: {
	value: string;
	onChange: (str: string) => void;
	type: "title" | "description";
	char_limit?: number;
	placeholder?: string;
}) {
	const data = Object.keys(common_utils.PlaceholderTokens)
		.filter((val: `$${string}`) =>
			props.type === "title"
				? !common_utils.PlaceholderTokens[val].not_allowed_in_title
				: true
		)
		.map((val) => val.substring(1));

	return (
		<ReactTextareaAutocomplete
			placeholder={props.placeholder}
			maxLength={props.char_limit}
			value={props.value}
			onChange={(e) => {
				props.onChange(e.target.value);
			}}
			onKeyPress={(e) => {
				if (props.type === "description") return;
				if (e.key === "Enter") e.preventDefault();
			}}
			rows={props.type === "description" ? 5 : 1}
			listClassName="relative"
			dropdownClassName="absolute bg-base-light z-[1002] text-white mt-6 shadow-lg rounded-sm border-sesh-hover border max-h-52 overflow-auto"
			containerClassName={"relative"}
			loadingComponent={() => <div>Loading</div>}
			// wrap={props.type === "text" ? "off" : undefined}
			className={classNames("input relative", {
				"resize-none overflow-y-hidden": props.type === "title",
				textarea: props.type === "description",
			})}
			renderToBody
			minChar={0}
			trigger={{
				$: {
					component: ({ selected, entity }) => {
						const description = common_utils.PlaceholderTokens["$" + entity]?.description;
						const content = (
							<div
								className={classNames(
									"flex flex-col px-2 py-1 text-sm",
									{
										"bg-sesh-primary text-black": selected,
									}
								)}
							>
								<div>{typeof entity === 'string' ? entity : JSON.stringify(entity)}</div>
								<div className="text-xs opacity-70">
									{description}
								</div>
							</div>
						);
						// @ts-ignore - React 18 type strictness workaround
						return content;
					},
					dataProvider: (token) => {
						return data.filter((item) =>
							item.toLowerCase().startsWith(token.toLowerCase())
						);
					},
					output: (item, trigger) => `$${item}`,
				},
			}}
		></ReactTextareaAutocomplete>
	);
}
